import http from '@services/http'
import {
  IClubPortals,
  IHotMatch,
  ILiveScore,
  IGiftbox,
  IAttendance,
  IMyInfo,
  IOpenGiftbox,
  ICouponRegisterInfo,
  IGameBanners,
  IBettingRules,
  IComponentBet,
  IEventRewardInfo,
  ILossLimit,
  ISelfUsageRestriction,
  IGiftBoxGameBanners,
  IFriendInvitationInvitor,
  IFriendInvitationInvitedUsers,
  IFriendInvitationRewardReceive,
  IFriendInvitationPossibleToInvitor,
  INoticeBadge,
  INotices,
  INotice,
  IGameTips,
  ICheckAppVersion,
  IForefrontPopups,
  INoticeCreate,
  IExtraOddsItemDetail,
  IReceiveDailyBettingEventReward,
  IRegistrationSourceDefs,
  IReceiveUserActivityReward,
  IPushwooshInfo,
  IUserCommunicationBlockInfo,
  IRegistrationCommunicationBlock,
  ICommunicationBlockUserInfos,
  IUnblockCommunicationBlockUser,
  IMatchupBottomGameBanner,
  IGameHomeMainBanners,
  ISportIssueList,
  ISportTalkDashboardList,
  IChatBanner,
  IBettingHistoryBanner,
  IMaintenanceBanner,
  IRequireLossLimitPopupTarget,
  IFriendInvitationAllRewardReceive,
  IReceivedExtraPaymentReward,
} from '@protocol/component'

export default {
  getClubPortals(data: IClubPortals.Params): Promise<IClubPortals.Schema> {
    return http.get('component/clubPortals', data || {})
  },
  getHotMatch(data: IHotMatch.Params): Promise<IHotMatch.Schema> {
    return http.get('component/hotMatch', data || {})
  },
  getLiveScore(data: ILiveScore.Params): Promise<ILiveScore.Schema> {
    return http.get('component/liveScore', data || {})
  },
  getGiftbox(data: IGiftbox.Params): Promise<IGiftbox.Schema> {
    return http.get('component/giftbox', data || {})
  },
  openGiftbox(data: IOpenGiftbox.Params): Promise<IOpenGiftbox.Schema> {
    return http.post('/component/openGiftbox', data || {})
  },
  receiveAttendance(data: IEventRewardInfo.Params): Promise<IEventRewardInfo.Schema> {
    return http.post('/component/receiveAttendance', data || {})
  },
  getAttendance(data: IAttendance.Params): Promise<IAttendance.Schema> {
    return http.get('component/attendance', data || {})
  },
  getMyInfo(data: IMyInfo.Params): Promise<IMyInfo.Schema> {
    return http.get('component/myInfo', data || {})
  },
  registerCoupons(data: ICouponRegisterInfo.Params): Promise<ICouponRegisterInfo.Schema[]> {
    return http.post('component/registerCoupons', data || {})
  },
  validateCoupons(data: ICouponRegisterInfo.Params): Promise<ICouponRegisterInfo.Schema[]> {
    return http.post('component/validateCoupons', data || {})
  },
  getMatchupBanners(data: IGameBanners.Params): Promise<IGameBanners.Schema> {
    return http.get('component/matchupBanners', data || {})
  },
  getPublishedBanners(data: IGameBanners.Params): Promise<IGameBanners.Schema> {
    return http.get('component/publishedBanners', data || {})
  },
  getGiftBoxGameBanners(data: IGiftBoxGameBanners.Params): Promise<IGiftBoxGameBanners.Schema> {
    return http.get('component/giftBoxGameBanners', data || {})
  },
  getMaintenanceBanner(data: IMaintenanceBanner.Params): Promise<IMaintenanceBanner.Schema> {
    return http.get('component/maintenanceBanner', data || {})
  },
  getBettingRules(data: IBettingRules.Params): Promise<IBettingRules.Schema> {
    return http.get('component/bettingRules', data || {})
  },
  bet(data: IComponentBet.Params): Promise<IComponentBet.Schema> {
    return http.post('component/bet', data || {})
  },
  fetchLossLimitAmountAndUserLossMoney(data: ILossLimit.Params): Promise<ILossLimit.Schema> {
    return http.post('component/lossLimitAmountAndUserLossMoney', data || {})
  },
  saveLossLimitAmount(data: ILossLimit.Params): Promise<ILossLimit.Schema> {
    return http.post('component/saveLossLimitAmount', data || {})
  },
  saveSelfUsageRestriction(data: ISelfUsageRestriction.Params): Promise<ISelfUsageRestriction.Schema> {
    return http.post('component/saveSelfUsageRestriction', data || {})
  },
  getFriendInvitationInvitor(data: IFriendInvitationInvitor.Params): Promise<IFriendInvitationInvitor.Schema> {
    return http.get('component/friendInvitationInvitor', data || {})
  },
  getFriendInvitationInvitedUsers(
    data: IFriendInvitationInvitedUsers.Params,
  ): Promise<IFriendInvitationInvitedUsers.Schema> {
    return http.get('component/friendInvitationInvitedUsers', data || {})
  },
  receiveFriendInvitationReward(
    data: IFriendInvitationRewardReceive.Params,
  ): Promise<IFriendInvitationRewardReceive.Schema> {
    return http.post('component/receiveFriendInvitationReward', data || {})
  },
  receiveAllFriendInvitationReward(
    data: IFriendInvitationAllRewardReceive.Params,
  ): Promise<IFriendInvitationAllRewardReceive.Schema> {
    return http.post('component/receiveAllFriendInvitationReward', data || {})
  },
  isPossibleToInvitor(
    data: IFriendInvitationPossibleToInvitor.Params,
  ): Promise<IFriendInvitationPossibleToInvitor.Schema> {
    return http.get('component/isPossibleToInvitor', data || {})
  },
  fetchNoticeBadgeEnabled(data: INoticeBadge.Params): Promise<INoticeBadge.Schema> {
    return http.get('component/noticeBadgeEnabled', data || {})
  },
  getNotices(data: INotices.Params): Promise<INotices.Schema> {
    return http.get('component/notices', data || {})
  },
  getNotice(data: INotice.Params): Promise<INotice.Schema> {
    return http.get('component/notice', data || {})
  },
  createNoticeReadHistory(data: INoticeCreate.Params): Promise<INoticeCreate.Schema> {
    return http.get('component/createNoticeReadHistory', data || {})
  },
  createAllNoticeReadHistory(data: INoticeCreate.Params): Promise<INoticeCreate.Schema> {
    return http.get('component/createAllNoticeReadHistory', data || {})
  },
  getPostedTips(data: IGameTips.Params): Promise<IGameTips.Schema> {
    return http.post('component/getPostedTips', data || {})
  },
  checkAppVersion(data: ICheckAppVersion.Params): Promise<ICheckAppVersion.Schema> {
    return http.post('component/checkAppVersion', data || {})
  },
  getForefrontPopups(data: IForefrontPopups.Params): Promise<IForefrontPopups.Schema> {
    return http.post('component/getForefrontPopups', data || {})
  },
  fetchTips(data: INotices.Params): Promise<INotices.Schema> {
    return http.get('component/tips', data || {})
  },
  fetchHomeBanners(data: IGameBanners.Params): Promise<IGameBanners.Schema> {
    return http.get('component/homeBanners', data || {})
  },
  fetchHomeMainBanners(data: IGameHomeMainBanners.Params): Promise<IGameHomeMainBanners.Schema> {
    return http.get('component/homeMainBanners', data || {})
  },
  fetchMatchupListBanners(data: IGameBanners.Params): Promise<IGameBanners.Schema> {
    return http.get('component/matchupListBanners', data || {})
  },
  fetchMatchupBottomBanner(): Promise<IMatchupBottomGameBanner.Schema> {
    return http.get('component/matchupBottomBanner', {})
  },
  fetchBettingHistoryBanner(): Promise<IBettingHistoryBanner.Schema> {
    return http.get('component/bettingHistoryBanner', {})
  },
  fetchChatBanner(): Promise<IChatBanner.Schema> {
    return http.get('component/chatBanner', {})
  },
  fetchExtraOddsItemDetails(data: IExtraOddsItemDetail.Params): Promise<IExtraOddsItemDetail.Schema> {
    return http.get('component/extraOddsItemDetails', data || {})
  },
  receiveDailyBettingEventReward(data: IReceiveDailyBettingEventReward.Params)
    : Promise<IReceiveDailyBettingEventReward.Schema> {
    return http.post('component/receiveDailyBettingEventReward', data || {})
  },
  receiveExtraPaymentReward(data: IReceivedExtraPaymentReward.Params)
    : Promise<IReceivedExtraPaymentReward.Schema> {
    return http.post('component/receiveExtraPaymentReward', data || {})
  },
  fetchRegistrationSourceDefs(data: IRegistrationSourceDefs.Params): Promise<IRegistrationSourceDefs.Schema> {
    return http.get('component/getRegistrationSourceDefs', data || [])
  },
  receiveUserActivityReward(data: IReceiveUserActivityReward.Params): Promise<IReceiveUserActivityReward.Schema> {
    return http.post('component/receiveUserActivityReward', data || [])
  },
  registerPushwooshInfo(data: IPushwooshInfo.Params) {
    return http.post('component/registerPushwooshInfo', data || {})
  },
  fetchCommunicationBlockUserInfos(
    data: ICommunicationBlockUserInfos.Params,
  ): Promise<ICommunicationBlockUserInfos.Schema> {
    return http.post('component/getCommunicationBlockUserInfos', data || {})
  },
  fetchUserCommunicationBlockInfo(
    data: IUserCommunicationBlockInfo.Params,
  ): Promise<IUserCommunicationBlockInfo.Schema> {
    return http.post('component/getUserCommunicationBlockInfo', data || {})
  },
  setRegistrationCommunicationBlock(
    data: IRegistrationCommunicationBlock.Params,
  ): Promise<IRegistrationCommunicationBlock.Schema> {
    return http.post('component/setRegistrationCommunicationBlock', data || {})
  },
  unblockCommunicationBlockUser(
    data: IUnblockCommunicationBlockUser.Params,
  ): Promise<IUnblockCommunicationBlockUser.Schema> {
    return http.post('component/unblockCommunicationBlockUser', data || {})
  },
  fetchSportDashboardList(data: ISportTalkDashboardList.Params): Promise<ISportTalkDashboardList.Schema> {
    return http.post('component/fetchSportDashboardList', data || {})
  },
  fetchSportIssueList(data: ISportIssueList.Params): Promise<ISportIssueList.Schema> {
    return http.post('component/fetchSportIssueList', data || {})
  },
  fetchRequireLossLimitPopupTarget(): Promise<IRequireLossLimitPopupTarget.Schema> {
    return http.post('component/requiredLossLimitPopupTarget', {})
  },
}
